<template>
  <el-row style="height: 860px;width: 100%;margin-top: 40px;">
    <el-row style="width: 100%;height: 70px;">
      <el-row class="about-us" />
    </el-row>
    <el-row class="document-class">
      <el-row style="width: 100%;height: 240px;">
        <el-row class="company-photo" />
      </el-row>
      <el-row style="width: 100%;margin-top: 10px;">
        <div class="company-info">{{companyInfo1}}</div>
        <div class="company-info">{{companyInfo2}}</div>
      </el-row>
      <el-row style="height: 240px;margin-top: 10px;width: 100%;">
        <el-row class="about-us-ext" />
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'AboutUs',
  data() {
    return {
      companyInfo1: '瑜岿科技是一家专注于能源互联网、园区物联网产品及解决方案研发的创新型科技公司。为企业和集成商提供能源物联网云平台、智慧园区云平台、智能用电、多能互补、智慧运维、电能质量治理等系统解决方案以及相关的智能传感、测控装置。业务主要涉及以下三大领域：综合能源服务、智慧园区、分布式光伏。',
      companyInfo2: '坚持以客户为中心，以产品为核心，以创新为驱动，让绿色能源、智慧服务触手可及。',
      m: '致力于能源物联网的持续创新，让绿色能源触手可及。',
      v: '成为世界一流智慧能源整体解决方案提供商。',
      s: '客户第一，尊重人才，开拓创新，合作共赢。'
    }
  }
}
</script>

<style scoped>
  .about-us {
    background: url("../../assets/aboutus.png") no-repeat;
    background-size: 100% 100%;
    width: 70%;
    margin-left: 15%;
    height: 60px;
    /*cursor: pointer;*/
  }
  .document-class {
    height: 540px;
    width: 94%;
    margin-left: 3%;
    margin-top: 20px;
  }
  .company-photo {
    background-image: url("../../assets/company.jpg");
    width: 100%;
    height: 240px;
    background-size: cover;
    /*cursor: pointer;*/
  }
  .company-info {
    text-align: justify;
    line-height: 30px;
    white-space: pre-wrap;
    text-indent: 2em;
  }
  .m-class {
    background: url("../../assets/m.png") no-repeat;
    width: 50px;
    height: 50px;
  }
  .v-class {
    background: url("../../assets/v.png") no-repeat;
    width: 50px;
    height: 50px;
  }
  .s-class {
    background: url("../../assets/s.png") no-repeat;
    width: 50px;
    height: 50px;
  }
  .about-us-ext {
    background: url("../../assets/aboutusext.png") no-repeat;
    width: 100%;
    height: 240px;
    background-size: cover;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/AboutUs.vue